// Mini Games public API (saweria-back /mini-games). See docs/mini-games.md in saweria-back.
import { _get, _post } from "../../utils/request";

export const fetchMiniGames = async (username) => (await _get(`mini-games/${username}`)).json.data;

export const fetchMiniGame = async (username, slug) =>
  (await _get(`mini-games/${username}/${slug}`)).json.data;

export const fetchMiniGameOrder = async (id) => (await _get(`mini-games/order/${id}`)).json.data;

// ticket code -> { room_id, grant, expires_in, player, rejoin }
export const redeemTicketCode = async (username, slug, code) =>
  (await _post(`mini-games/${username}/${slug}/redeem`, { json: { code } })).json.data;

// backend error code, e.g. "INVALID_CODE"
export const apiErrorCode = (error) => error?.response?.json?.message || null;

export const miniGameOrderUrl = (username, slug) => `mini-games/order/${username}/${slug}`;
export const miniGameTrackPath = (id) => `/mini-games/order/${id}`;
export const miniGamePlayPath = (username, slug) => `/${username}/mini-games/${slug}/play`;
// streamer room and OBS overlay of a game
export const miniGameHostPath = (slug) => `/mini-games/${slug}`;
export const miniGameOverlayPath = (slug) => `/widgets/mini-games/${slug}`;
// how-to page of a game (streamer setup + how supporters join)
export const miniGameDocsPath = (slug) => `/docs/mini-games/${slug}`;
